<template>
    <div>
        <Header></Header>
        <div class="main-table">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">就医记录</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/jyjl/jyjl/'+pfrom+'/'+pid }" @click="goBack()">检验记录</el-breadcrumb-item>
                <el-breadcrumb-item>明细</el-breadcrumb-item>
            </el-breadcrumb>
            <el-table
                    :data="list"
                    :row-class-name="yCRowClass"
                    size="medium"
                    style="width:100%;margin-top:20px;margin-bottom: 20px;">
                <el-table-column prop="xmmc" label="明细项目" ></el-table-column>
                <el-table-column prop="jyjg" label="结果" ></el-table-column>
                <el-table-column prop="dw" label="单位" width="125"></el-table-column>
                <el-table-column prop="ckz" label="参考值">
                    <template slot-scope="scope">
                        {{scope.row.ckz ? scope.row.ckz : '-'}}
                    </template>
                </el-table-column>
                <el-table-column prop="sfyc" label="是否异常" width="125">
                    <template slot-scope="scope">
                        {{scope.row.sfyc ? scope.row.sfyc : '正常'}}
                    </template>
                </el-table-column>
            </el-table>
            <!--<el-pagination-->
                    <!--background-->
                    <!--layout="prev, pager, next ,total"-->
                    <!--:page-size="pageSize"-->
                    <!--:total="totalSize"-->
                    <!--:current-page.sync="currentPage"-->
                    <!--@current-change="changePage">-->
            <!--</el-pagination>-->
        </div>
    </div>
</template>

<script>
    import Header from './components/Header.vue'
    import {findJyjlMx} from '@/api/biApi.js'
    export default{
        data(){
            return {
                list:[],
                pfrom:'',
                pid:'',
                id:'',
                currentPage:1,
                pageSize:100,
                totalSize:0,
            }
        },
        components: {
            Header
        },
        mounted(){
            this.pfrom = this.$route.params.pfrom
            this.pid = this.$route.params.pid

            this.id = this.$route.params.id
            if(!this.pfrom || !this.pid || !this.id){
                this.$router.push({ name: '/'})
            }
            this.getList(1,this.pageSize)
        },
        methods:{
            goBack(){
                console.log('xxx')
            },
            getList(page,size){
                this.currentPage = page
                this.list = [];
                findJyjlMx({
                    "jybgid":this.id,
                    "size":size,
                    "page":page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        this.list = res.list
                    }
                    this.totalSize = res && res.total ? res.total : 0;
                }).catch(err=>{
                    this.$message.error('获取检验记录明细失败');
                })
            },
            yCRowClass({row,rowIndex}){
                if(row.sfyc && row.sfyc == '偏高'){
                    return 'yc_high';
                }
                if(row.sfyc && row.sfyc == '偏低'){
                    return 'yc_low';
                }
            },
            changePage(page){
                this.getList(page,this.pageSize)
            },
        }
    }
</script>
<style lang="scss">
    .main-table{
        max-width: 1280px;
        margin:0 auto;
        padding-left:10px;
        padding-right:10px;

        .el-pagination{
            float: right;
            margin: 10px 0px 10px 0px;
        }
        .yc_high {
            color:#F56C6C;
            background: #FCE2E2;
        }
        .yc_low{
            color:#409EFF;
            background: #C7E2FE;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc/jyjl-jyjl-mx.vue